import { MsalAuthProvider, LoginType } from 'react-aad-msal';
import { CacheLocation } from 'msal';
 
const clientId: string = process.env.REACT_APP_CLIENT_ID ? process.env.REACT_APP_CLIENT_ID : '';

// Msal Configurations
const config = 
{
  auth: 
  {
    authority: 'https://login.microsoftonline.com/b8495907-4bdc-4878-a828-a90219cad36f',
    clientId: clientId,
    postLogoutRedirectUri: window.location.origin,
    redirectUri: window.location.origin,
    validateAuthority: true,
  },
  cache: 
  {
    cacheLocation: "sessionStorage" as CacheLocation,
    storeAuthStateInCookie: false
  }
};
 
// Authentication Parameters
const authenticationParameters = {scopes: ["openid"]}
 
// Options
const options = 
{
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin + '/auth.html'
}
 
export const authProvider = new MsalAuthProvider(config, authenticationParameters, options)